"use strict";
/* globals module */
/**
 * @module notificationsPublishRoute
 * @description Baasic Notifications Publish Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var _1 = require("./");
var NotificationsPublishRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsPublishRoute, _super);
    function NotificationsPublishRoute(appOptions, notificationsPublishBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsPublishBatchRoute = notificationsPublishBatchRoute;
        _this.createRoute = 'notifications/publish';
        return _this;
    }
    NotificationsPublishRoute.prototype.batch = function () {
        return this.notificationsPublishBatchRoute;
    };
    /**
     * Parses create publish route; this route does not expose any additional options.
     * @method
     * @example notificationsPublishRoute.create();
     */
    NotificationsPublishRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    var _a, _b;
    NotificationsPublishRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsPublishBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsPublishBatchRoute !== "undefined" && _1.NotificationsPublishBatchRoute) === "function" ? _b : Object])
    ], NotificationsPublishRoute);
    return NotificationsPublishRoute;
}(common_1.BaseRoute));
exports.NotificationsPublishRoute = NotificationsPublishRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
